import jQuery from 'jquery'
import NProgress from 'nprogress'
import './nprogress.scss'

jQuery(function() {
  jQuery(document).on('page:fetch turbolinks:request-start', function() {
    NProgress.start()
  })
  jQuery(document).on('page:receive turbolinks:request-end', function() {
    NProgress.set(0.7)
  })
  jQuery(document).on('page:change turbolinks:load', function() {
    NProgress.done()
  })
  jQuery(document).on('page:restore turbolinks:request-end turbolinks:before-cache', function() {
    NProgress.remove()
  })
})

jQuery(function() {
  jQuery(document).on('ajaxStart', function() { NProgress.start() })
  jQuery(document).on('ajaxStop',  function() { NProgress.done()  })
})
